import { Component, HostListener, OnInit, inject } from '@angular/core';
import { BrandingService } from './@application/services/branding.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'rms-web-app';
  private branding = inject(BrandingService);

  ngOnInit(): void {
    // Re-apply the tenant brand on refresh, before any branded screen renders.
    this.branding.applyStoredBrand();
  }

  /**
   * ~20 components expose an isMobileScreen()/isTabScreen() that reads
   * window.innerWidth and is called straight from their templates. Nothing
   * re-ran change detection on resize, so those values went stale on rotate.
   * An empty listener on the root is enough — zone.js ticks the app for us.
   *
   * ponytail: blunt but one line. Migrate those call sites to ResponsiveService
   * if resize-time CD ever shows up in a profile.
   */
  @HostListener('window:resize')
  onWindowResize(): void {
  }
}
